import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const ModulesStyled = styled.div`
  /* Título y filtros (fechas) en una fila, como en las estadísticas de talent; sin el margen
     superior de 38 px (el padding lo da la página) */
  .title-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin: 0 0 24px;

    > .MuiGrid-item {
      flex: 0 1 auto;
      max-width: none;
    }

    .title {
      align-items: center;
      display: flex;
    }
  }

  .modules-wrapper {
    padding: 50px 0;
  }

  .buttons-wrapper {
    text-align: right;
  }
  
  .container-filters {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap-reverse;
    justify-content: flex-end;
    align-items: center;
    gap: 20px;
    
    /* Fechas sin fondo blanco, como en el resto de estadísticas */
    .MuiOutlinedInput-root,
    .submit {
      background-color: transparent;
    }
  }
  
  .phases_container {
    background-color: white;
  }

  .MuiTypography-h6 {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin: 0;
  }
  
  .bJaNID {
    text-align: center;
  }

  .stats-table-card {
    padding: 16px;
    background: ${tokens.color.background.default};
    border-radius: 6px;
    box-shadow: 0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06);

    .MuiToolbar-root {
      align-items: flex-end;
      padding: 0 0 16px;
    }
  }

  .stats-table-title {
    margin: 0 0 12px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${tokens.color.text.primary};
  }

  .stats-table-filters {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;

    .MuiTextField-root {
      width: 200px;
    }

    .MuiFormControlLabel-root {
      margin: 0;

      .MuiFormControlLabel-label {
        font-size: 14px;
        color: ${tokens.color.text.secondary};
      }
    }
  }

  .stats-table-card .MuiTableBody-root td {
    font-size: 13px;
    font-weight: 400;
  }
`

export default ModulesStyled
